export const sessionObjects = {
  user_email_id: 'banupriya0118@gmail.com',
  phone_number: '9551176020',
  user_name: '9551176020',
  first_name: 'Beam',
  last_name: 'New',
  user_status: '2',
  device_id: '',
  applicationUserId: 'bd30c685-6446-4c9b-9336-a96c66550072',
  user_type: '7',
  locale: '',
  user_pic: '',
  entityid: '254',
  approval_status: 'true',
  date_format: 'dd-MM-yyyy',
  currency: '1',
  decimal_places: '2',
  timezone: '388',
  classification: '3',
  entity: '254',
  entity_start:
    'Thu Oct 10 2024 00:00:00 GMT+0000 (Coordinated Universal Time)',
  entity_logo: '',
  entity_legal_name: 'BeamNew',
  entity_business_name: 'BeamNew',
  business_location_id: '1',
  timezone_offset: '05:30:00.0000000',
  timezone_offset_direction: '+',
  minute_offset: '330',
  mas_languages:
    '[{"locale_name":"English","locale_letter":"A","locale_code":"en-US","id":"1"}]',
  user_locale: 'en-US',
  locale_version: '1',
  login_type: 'Super Admin',
  crownicon:
    'https://ansio-solutions.s3.ap-south-1.amazonaws.com/farmsio/assets/images/crowns.png',
  short_code: 'BEAM',
  farmer_subscription: '0',
  ItemCount: '0',
  Role: 'erp.root.administrator.role',
  homepagelink: '/dashboard/region-analytics',
  homepagekey: 'dashboard_beam',
  unreadcount: '0',
  currency_symbol: '₹',
  erpuserentity: '[]',
  show_entity_dropdown: 'false',
  user_entity_id: '254',
  book_start_date: '',
  is_enable_multi_seller: '0',
  whatsapp_no: '',
  money_symbol: 'INR',
  reporter: '0',
  primary_schema: 'farmsio_uat',
  secondary_schema: 'farmsio_uat',
  second_schema: 'farmsio_uat',
  access_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJWX3cxTk1BTm1wdTBhRWVGeFJ0NEtxbVk2Q2ZzaHhPcjl3RVE0NDVyYVNVIn0.eyJleHAiOjE3MzYyMzk5MTksImlhdCI6MTczNjIzNjMxOSwianRpIjoiMWM4NzM4MTEtYWY3Yy00NGE0LWIxZDMtNTVlNTI0NTg2ZjdhIiwiaXNzIjoiaHR0cHM6Ly9rZXljbG9hay11YXQuYW5zaW9zb2x1dGlvbnMuY29tL2F1dGgvcmVhbG1zL2JlYW0tdWF0IiwiYXVkIjoiYWNjb3VudCIsInN1YiI6ImJkMzBjNjg1LTY0NDYtNGM5Yi05MzM2LWE5NmM2NjU1MDA3MiIsInR5cCI6IkJlYXJlciIsImF6cCI6ImJlYW0tdWF0Iiwic2Vzc2lvbl9zdGF0ZSI6ImNmZWVlNTkwLWYwZjUtNDAxZS1hYTRlLTg2MDhiOWYyMGYzNiIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cHM6Ly9sb2NhbGhvc3QiLCJodHRwOi8vbG9jYWxob3N0OjMwMDAiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iLCJkZWZhdWx0LXJvbGVzLWJlYW0tdWF0Il19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgZW1haWwgcHJvZmlsZSIsInNpZCI6ImNmZWVlNTkwLWYwZjUtNDAxZS1hYTRlLTg2MDhiOWYyMGYzNiIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYW1lIjoiQmVhbSBOZXciLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiI5NTUxMTc2MDIwIiwiZ2l2ZW5fbmFtZSI6IkJlYW0iLCJmYW1pbHlfbmFtZSI6Ik5ldyIsImVtYWlsIjoiYmFudXByaXlhMDExOEBnbWFpbC5jb20ifQ.DL0bCpvGQTCUxqm1YPmm6PYM1Cv9FoC7jwEaps4fLX1LckfNIYSV_eoCV2IhX3jUzTQTDvGVbg6_OghqDowxrDonmNVU8PXsOrHs7E2gjNedhB-VYDBpSIbnugFsbkMSPhurqA3_AaPy_T8hW3FG45uVYGVrG1c6MhIpx4rc6ufVcIews2qLXOJzJD4Qpe8ftYyVzEKZlTDdenUsYmLLOxgg5TMCVO5Nj87IiZ1bedlHigPWtdIQ7x_r876qrNfsq2y9rVJwSIbmpFvOBN99x7Jm6Iu7qwnb9_1bZs6N8AFa1u3H6BRX0mKhj6VRg6PnzftzpzUtcTvCn4KTpyHqqA'
};
